import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

const FormatUnderline = props => (
  <SvgIcon {...props} viewBox="0 0 32 32">
    <path d="M15.988 26c-4.192 0-8-3-8-9v-10c0-0.553 0.447-1 1-1 0.552 0 1 0.447 1 1v10c0 3.313 2.134 7 6 7s5.5-3.687 5.5-7v-10c0-0.553 0.447-1 1-1 0.552 0 1 0.447 1 1v10c-0.020 5.906-3.31 9-7.5 9zM25 28c0.553 0 1 0.447 1 1s-0.447 1-1 1h-18c-0.553 0-1-0.447-1-1s0.447-1 1-1h18z" />
  </SvgIcon>
);

export default FormatUnderline;
